import type { PrestationParticipationFormatted } from '@/api/prestations/prestations.types';
import { Badge, BadgeColor } from '@/components/Badge';
import { EntityLink } from '@/components/StyledLink';

export function EmployeeNameCell(props: { participation: PrestationParticipationFormatted }) {
  const { employee, employeeId } = props.participation;

  return (
    <div className="flex items-center gap-2">
      <EntityLink entity="employee" id={employee ? employeeId : null}>
        {employee?.beneficiary.lastName ?? '-'}
      </EntityLink>
      {employee?.isMissingFromTicketing && (
        <Badge color={BadgeColor.GRAY}>Absent de la liste des salariés</Badge>
      )}
    </div>
  );
}
